export const MainPageURLs = {
  mainPage: "/",
  tec: "/the-elder-commands",
  contact: "/contact",
  aboutMe: "/about-me",
  privacyPolicy: "/privacy-policy",
  cookiesPolicy: "/cookies-policy",
};